module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8588/img/iphone-frame.png"